import { PHONEMES } from "../content/phonemes";
import { TWISTERS } from "../content/twisters";
import type { Profile } from "../state/profile";

const CARDS_BY_PHONEME: Record<string, string[]> = {};
for (const t of TWISTERS) {
  for (const ph of t.phonemes) (CARDS_BY_PHONEME[ph] ??= []).push(t.id);
}

export function cardsForPhoneme(phonemeId: string): string[] {
  return CARDS_BY_PHONEME[phonemeId] ?? [];
}

/** 0..5 mastery for a phoneme: accuracy (clean-rate) scaled by how much
    practice volume backs it up, so one lucky attempt doesn't read as
    mastered. This is the canonical formula — plaques.ts's "8 phonemes at
    Mastery 5" check uses this same function. */
export function masteryFor(phonemeId: string, profile: Profile): number {
  const p = profile.phonemes[phonemeId];
  if (!p || p.attempts === 0) return 0;
  const rate = p.clean / p.attempts;
  const volume = Math.min(1, p.attempts / 20);
  return Math.round(rate * volume * 5);
}

export function weakestPhonemes(profile: Profile, n: number): string[] {
  return [...PHONEMES]
    .map((ph) => ({ id: ph.id, mastery: masteryFor(ph.id, profile) }))
    .sort((a, b) => a.mastery - b.mastery)
    .slice(0, n)
    .map((x) => x.id);
}

export function soundMapCompletion(profile: Profile, minMastery = 3): { done: number; total: number } {
  const done = PHONEMES.filter((ph) => masteryFor(ph.id, profile) >= minMastery).length;
  return { done, total: PHONEMES.length };
}
